<template>
  <div class="ds">
    <h2>Digital Foamboard</h2>
    <h1>Custom Design System</h1>

    <h4 class="ds__section-title">
      Image Run Component
    </h4>
    <section class="ds__section">
      <ColorRunPreview :images="imageRunImages" />
    </section>
  </div>
</template>

<script>
import ColorRunPreview from '@/components/ColorRunPreview'

export default {
  name: 'DesignSystem',

  components: {
    ColorRunPreview
  },

  data: () => ({
    imageRunImages: [
      /* eslint-disable no-secrets/no-secrets -- file names */
      'https://assets.stitchdesignlab.com/trim/fit-in/200x200/filters:upscale():format(webp)/stagevault-staging-copy/assets/options/12-04T15-50-13-522699_CORDUROY_MICRO_PRT_LS_0_3_4_scale.png',
      'https://assets.stitchdesignlab.com/trim/fit-in/200x200/filters:upscale():format(png)/stagevault-staging-copy/assets/options/12-04T15-50-15-317538_CORDUROY_MICRO_PRT_LS_2_3_4_scale.png',
      'https://assets.stitchdesignlab.com/trim/fit-in/200x200/filters:upscale():format(webp)/stagevault-staging-copy/assets/options/12-04T15-50-14-573735_CORDUROY_MICRO_PRT_LS_1_3_4_scale.png',
      'https://assets.stitchdesignlab.com/trim/fit-in/200x200/filters:upscale():format(webp)/stagevault-staging-copy/assets/options/12-04T15-50-13-522699_CORDUROY_MICRO_PRT_LS_0_3_4_scale.png',
      'https://assets.stitchdesignlab.com/trim/fit-in/200x200/filters:upscale():format(png)/stagevault-staging-copy/assets/options/12-04T15-50-15-317538_CORDUROY_MICRO_PRT_LS_2_3_4_scale.png',
      'https://assets.stitchdesignlab.com/trim/fit-in/200x200/filters:upscale():format(webp)/stagevault-staging-copy/assets/options/12-04T15-50-14-573735_CORDUROY_MICRO_PRT_LS_1_3_4_scale.png'
      /* eslint-enable no-secrets/no-secrets -- file names */
    ]
  })
}
</script>

<style lang="scss" scoped>
.ds {
  display: flex;
  flex-direction: column;
  padding: $spacer-unit-x2;
}

.ds__section {
  display: flex;
  flex-direction: column;
  margin-top: $spacer-unit-x2;
  padding: $spacer-unit;
  background-color: $white;
  border-radius: $border-radius-default;
}

.ds__section-title {
  margin-bottom: $spacer-unit;
}
</style>
